module.exports = __webpack_public_path__ + "static/2_3_game-tree-4_SL-ee5d12fe23c2aed031b2b5b7bdd653fe.svg";